var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.route)?_c('router-link',{class:_vm.styles,attrs:{"to":_vm.route}},[_vm._t("default")],2):_c('a',{class:_vm.styles,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }